import { useState } from "react";
import { motion } from "framer-motion";
import { Send, MapPin, Mail, ArrowUpRight } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6 },
  viewport: { once: true },
};

export default function ContactFooter() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", message: "" });
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setStatus("success");
      setForm({ name: "", email: "", phone: "", company: "", message: "" });
    } catch {
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  return (
    <>
      {/* CONTACT */}
      <section id="contatti" data-testid="contact-section" className="py-16 sm:py-24 lg:py-32 bg-[#0a0a0a] border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <motion.div {...fadeInUp}>
              <span className="font-mono text-xs tracking-[0.2em] text-[#FF3366] uppercase">CONTATTACI</span>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-tight">
                Inizia il tuo<br />
                <span className="text-[#A3A3A3]">progetto oggi</span>
              </h2>
              <p className="text-[#A3A3A3] font-body text-lg mt-6 max-w-lg">
                Compila il form e ti ricontatteremo entro 24 ore per discutere della tua strategia di marketing personalizzata.
              </p>

              <div className="mt-12 space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 border border-white/10 flex items-center justify-center flex-shrink-0">
                    <MapPin size={18} className="text-[#FF3366]" />
                  </div>
                  <div>
                    <p className="font-heading font-bold text-sm">NINFA.EU</p>
                    <p className="text-[#A3A3A3] text-sm">Agenzia Marketing Digitale</p>
                    <p className="text-[#A3A3A3] text-sm mt-1">Strada di Paderna, 2 Domagnano</p>
                    <p className="text-[#A3A3A3] text-sm">4 Piano - Centro Fiorina</p>
                    <p className="text-[#A3A3A3] text-sm">Repubblica di San Marino</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 border border-white/10 flex items-center justify-center flex-shrink-0">
                    <Mail size={18} className="text-[#FF3366]" />
                  </div>
                  <div>
                    <p className="font-heading font-bold text-sm">info@ninfa.eu</p>
                    <p className="text-[#A3A3A3] text-xs font-mono">RISPONDIAMO ENTRO 24H</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div {...fadeInUp}>
              <form onSubmit={handleSubmit} data-testid="contact-form" className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-xs font-mono tracking-[0.2em] text-[#A3A3A3] mb-2">NOME E COGNOME *</label>
                    <input
                      data-testid="contact-name-input"
                      type="text"
                      value={form.name}
                      onChange={update("name")}
                      className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-mono tracking-[0.2em] text-[#A3A3A3] mb-2">EMAIL *</label>
                    <input
                      data-testid="contact-email-input"
                      type="email"
                      value={form.email}
                      onChange={update("email")}
                      className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-xs font-mono tracking-[0.2em] text-[#A3A3A3] mb-2">TELEFONO</label>
                    <input
                      data-testid="contact-phone-input"
                      type="tel"
                      value={form.phone}
                      onChange={update("phone")}
                      className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-mono tracking-[0.2em] text-[#A3A3A3] mb-2">AZIENDA</label>
                    <input
                      data-testid="contact-company-input"
                      type="text"
                      value={form.company}
                      onChange={update("company")}
                      className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-mono tracking-[0.2em] text-[#A3A3A3] mb-2">MESSAGGIO *</label>
                  <textarea
                    data-testid="contact-message-input"
                    value={form.message}
                    onChange={update("message")}
                    rows={4}
                    className="w-full bg-transparent border-b-2 border-white/20 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#FF3366] transition-colors font-mono resize-none"
                    required
                  />
                </div>

                {status === "success" && (
                  <div data-testid="contact-success-message" className="bg-green-500/10 border border-green-500/30 text-green-400 px-4 py-3 font-mono text-sm">
                    Messaggio inviato con successo! Ti ricontatteremo entro 24 ore.
                  </div>
                )}
                {status === "error" && (
                  <div data-testid="contact-error-message" className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 font-mono text-sm">
                    Errore nell'invio. Riprova piu tardi.
                  </div>
                )}

                <button
                  type="submit"
                  data-testid="contact-form-submit"
                  disabled={sending}
                  className="bg-[#FF3366] text-white font-bold uppercase tracking-widest px-10 py-4 text-sm hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-50 flex items-center gap-3"
                >
                  <Send size={18} />
                  {sending ? "INVIO IN CORSO..." : "INVIA RICHIESTA"}
                </button>
                <p className="text-[#A3A3A3] text-xs font-mono">
                  Cliccando su "Invia Richiesta" accetti la nostra Privacy Policy
                </p>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer data-testid="footer" className="bg-[#050505] border-t border-white/10 py-10 sm:py-12">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-2">
              <span className="font-heading text-3xl font-black tracking-tighter">NINFA</span>
              <p className="text-[#A3A3A3] text-sm mt-4 max-w-sm font-body">
                Marketing Digitale, Innovazione, Brevetti, Piattaforme Tecnologiche e Sviluppo App.
              </p>
            </div>
            <div>
              <h4 className="font-mono text-xs tracking-[0.2em] text-[#FF3366] mb-4">NAVIGAZIONE</h4>
              <div className="space-y-2">
                {["Servizi", "Innovazione", "Chi Siamo", "Prezzi", "Blog", "Contatti"].map((l) => (
                  <a
                    key={l}
                    href={`#${l.toLowerCase().replace(/\s/g, "-")}`}
                    className="block text-[#A3A3A3] text-sm hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 className="font-mono text-xs tracking-[0.2em] text-[#FF3366] mb-4">CONTATTI</h4>
              <p className="text-[#A3A3A3] text-sm">info@ninfa.eu</p>
              <p className="text-[#A3A3A3] text-sm mt-2">Strada di Paderna, 2</p>
              <p className="text-[#A3A3A3] text-sm">Domagnano, San Marino</p>
              <a
                href="/admin"
                data-testid="footer-admin-link"
                className="inline-flex items-center gap-1 text-[#A3A3A3] text-xs font-mono mt-6 hover:text-[#FF3366] transition-colors"
              >
                ADMIN <ArrowUpRight size={12} />
              </a>
            </div>
          </div>
          <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-[#A3A3A3] text-xs font-mono">
              &copy; {new Date().getFullYear()} NINFA.EU — P.IVA 18086141001
            </p>
            <p className="text-[#A3A3A3] text-xs font-mono">
              REPUBBLICA DI SAN MARINO
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
